import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import TextField from '../../../shared/form-elements/textarea';
import ModalBox from '../../../shared/modal';

const Form = props => (
	<div className="config-edit__wrap">
		<form action="" className="ui-form" onSubmit={props.handleSubmit(data => props.configFormSubmit(data))}>
			<div className="ui-form__element">
				<Field name="wm_config" placeholder={props.intl('Config')} component={TextField} />
			</div>
			<div className="ui-form__element buttons-wrap">
				<button className="ui-btn ui-btn-primary">{props.intl('Save')}</button>
			</div>
		</form>
	</div>
);

const Main = props => (
	<ModalBox
		title={props.intl('Edit WM config')}
		body={Form(props)}
		isOpen={props.shouldShowConfigForm}
		onClose={props.toggleConfigForm}
		className="create-config-modal"
	/>
);

Form.propTypes = {
	intl: PropTypes.func,
	handleSubmit: PropTypes.func,
	configFormSubmit: PropTypes.func
};

Main.propTypes = {
	intl: PropTypes.func,
	shouldShowConfigForm: PropTypes.bool,
	toggleConfigForm: PropTypes.func
};

export default formName =>
	reduxForm({
		form: formName
	})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/wm/components/config-form/main.js